/**
 * セット商品（_setid で紐づく line items）をまとめて削除
 */
async function cbsRemoveSetFromCart(setId) {
  if (!setId) return;

  const cart = await fetch('/cart.js').then((response) => response.json());
  const updates = {};

  cart.items.forEach((item) => {
    if (item.properties && String(item.properties._setid) === String(setId)) {
      updates[item.key] = 0;
    }
  });

  if (Object.keys(updates).length === 0) return;

  const response = await fetch('/cart/update.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ updates }),
  });

  if (!response.ok) {
    alert('セット商品の削除に失敗しました。');
    return;
  }

  window.location.reload();
}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-set-remove]').forEach((button) => {
    button.addEventListener('click', (event) => {
      event.preventDefault();
      const setId = button.dataset.setRemove;
      const title = button.dataset.productTitle || 'セット商品';
      if (window.confirm(`${title}をカートから削除しますか？`)) {
        cbsRemoveSetFromCart(setId);
      }
    });
  });
});
